var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-upload',{attrs:{"action":_vm.uploadImgUrl,"headers":_vm.headers},on:{"change":_vm.handleChange}},[_c('a-button',[_c('a-icon',{attrs:{"type":"upload"}}),_vm._v(" 上传附件 ")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }